import type { ComponentsVariants, Theme } from '@mui/material/styles';

export const getButtonVariants = (): ComponentsVariants<Theme>['MuiButton'] => [
    {
        props: { variant: 'outlined', color: 'grayscale' },
        style: ({ theme }) => ({
            borderColor: theme.colors.border['interactive-subtle'],
            backgroundColor: theme.colors.background['interactive-subtle'],
            color: theme.colors.text.interactive,

            '&:hover': {
                borderColor: theme.colors.border['interactive-subtle-hover'],
                backgroundColor: theme.colors.background['interactive-subtle-hover'],
            },

            '&.Mui-disabled': {
                backgroundColor: 'transparent',
            },
        }),
    },
    {
        props: { variant: 'contained', color: 'grayscale' },
        style: () => ({
            // Intentionally empty — no contained-grayscale styling in this theme
        }),
    },
    {
        props: { variant: 'text', color: 'grayscale' },
        style: ({ theme }) => ({
            // When button used as link, some additional styles kick in and override this, thus increased specificity.
            '&&': {
                color: theme.colors.text.interactive,
            },
        }),
    },
];
